// Reserved headers that are not allowed
export const RESERVED_HEADERS = [
	"host",
	"content-length",
	"transfer-encoding",
	"connection",
	"te",
	"trailer",
	"upgrade",
	":authority",
	":method",
	":path",
	":scheme",
];

export const MAX_HEADER_KEY_LENGTH = 256;
export const MAX_HEADER_VALUE_LENGTH = 1024;

export const CUSTOM_HEADER_ERROR_MESSAGES = {
	CANNOT_BE_EMPTY_KEY: "Key cannot be empty",
	CANNOT_BE_EMPTY_VALUE: "Value cannot be empty",
	INVALID_KEY_FORMAT: "Can only contain letters, numbers, underscores, and dashes",
	RESERVED_HEADER: "Is a reserved header and cannot be configured",
	KEY_ALREADY_EXISTS: "Key already exists",
	KEY_TOO_LONG: `Key cannot exceed ${MAX_HEADER_KEY_LENGTH} characters`,
	VALUE_TOO_LONG: `Value cannot exceed ${MAX_HEADER_VALUE_LENGTH} characters`,
	VALUE_HAS_NEWLINE: "Value cannot contain newline characters",
};

export const MAX_CUSTOM_HEADERS = 10;

export const CUSTOM_HEADER_MODAL_DETAILS = {
	REQUIRED: {
		header: "Custom Header Required",
		body: "Custom headers are enabled. Please provide at least one header in the ‘Custom Headers’ section.",
	},
	DUPLICATE_KEY: {
		header: "Duplicate Custom Header Key",
		body: "You cannot add a custom header with a key that is already present. Each custom header key must be unique.",
	},
	INVALID_INPUT: {
		header: "Invalid Input for Custom Header",
		body: "One or more fields in Custom Headers section are invalid. Please refer to the error messages next to the input fields.",
	},
};
